import { checkNode } from './index';

checkNode();

// So this is a valid ESM module, too.
export = {};
